import React, { useState, useEffect, memo } from "react";
//MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { DataGrid } from "@mui/x-data-grid";
import "./ModalCredenciais.scss";
import { Link } from "react-router-dom";
import { format } from "date-fns";

import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";

import { generateExcelFile } from "../../../../shared/components/excelUtils/exportExcel";

function ModalCredenciais({ openModal, handleClose, orcamentos }) {
  const [rows, setRows] = useState([]);
  const [permRows, setPermRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [dataInicio, setDataInicio] = useState(null);
  const [dataFim, setDataFim] = useState(null);

  useEffect(() => {
    const tempRows = [];
    orcamentos.forEach((or, index) => {
      // Usar dados já calculados pelo backend
      const expirado = or.status === "EXPIRADO";
      const emAjuste = or.status === "EM_AJUSTE";
      const diasRestantes = Math.ceil(or.diasAteExpirar);

      tempRows.push({
        id: or.cliente._id + index,
        idCliente: or.cliente._id,
        nome: or.cliente.nome,
        contacto: or.cliente.contacto,
        numeroOrcamento: or.numero,
        dataExpiracaoCredencial: format(
          new Date(or.dataExpiracaoCredencial),
          "dd/MM/yyyy",
        ),
        dataCredencial: format(new Date(or.dataCredencial), "dd/MM/yyyy"),
        nrCredencial: or.nrCredencial,
        total: or.total.toLocaleString("pt-Br") + "$00",
        expirado: expirado,
        emAjuste: emAjuste,
        medicoResponsavel: or.medico_responsavel.name,
        diasRestantes: diasRestantes,
        codigo: or.codigo,
        instituicaoCobertura: or.instituicaoCobertura?.nome || "",
        status: or.status,
      });
    });
    setRows(tempRows);
    setPermRows(tempRows);
  }, [orcamentos]);

  // ✅ CORREÇÃO: Adicionar permRows como dependência
  useEffect(() => {
    filterData();
  }, [searchTerm, dataInicio, dataFim, permRows]);

  const columns = [
    {
      field: "nome",
      headerName: "Nome",
      flex: 1.5,
      renderCell: (params) => {
        return (
          <span>
            <Link
              to={`/clientes/${params.row.idCliente}-orcamento`}
              className={`modalProcedimentosPorAgendar__link ${
                params.row.expirado && "modalCredencial__row__expirado"
              }`}
            >
              {params.row.nome}
            </Link>
          </span>
        );
      },
    },
    {
      field: "nrCredencial",
      headerName: "Nr Credencial",
      flex: 1,
      renderCell: (params) => {
        return (
          <span
            className={`${
              params.row.expirado && "modalCredencial__row__expirado"
            } marcacoesAdministrativo__nome__medico__span`}
          >
            {params.row.nrCredencial}
          </span>
        );
      },
    },
    {
      field: "codigo",
      headerName: "Codigo Orc",
      flex: 1,
      renderCell: (params) => {
        return (
          <span
            className={`${
              params.row.expirado && "modalCredencial__row__expirado"
            } marcacoesAdministrativo__nome__medico__span`}
          >
            {params.row.codigo}
          </span>
        );
      },
    },
    {
      field: "dataCredencial",
      headerName: "Data de Emissão",
      flex: 1,
      renderCell: (params) => {
        return (
          <span
            className={`marcacoesAdministrativo__nome__medico__span ${
              params.row.expirado && "modalCredencial__row__expirado"
            }`}
          >
            {params.row.dataCredencial}
          </span>
        );
      },
    },
    {
      field: "dataExpiracaoCredencial",
      headerName: "Data Expiração",
      flex: 1,
      renderCell: (params) => {
        return (
          <span
            className={`marcacoesAdministrativo__nome__medico__span ${
              params.row.expirado && "modalCredencial__row__expirado"
            }`}
          >
            {params.row.dataExpiracaoCredencial}
          </span>
        );
      },
    },
    {
      field: "diasRestantes",
      headerName: "Estado",
      flex: 2,
      renderCell: (params) => {
        let texto;
        let classeExtra = "";

        if (params.row.expirado) {
          const diasExpirado = Math.abs(params.row.diasRestantes);
          texto = `Expirado há ${diasExpirado} ${
            diasExpirado === 1 ? "dia" : "dias"
          }`;
          classeExtra = "modalCredencial__row__expirado";
        } else if (params.row.emAjuste) {
          texto = `Em janela de ajuste (${params.row.diasRestantes} ${
            params.row.diasRestantes === 1 ? "dia restante" : "dias restantes"
          })`;
          classeExtra = "modalCredencial__row__ajuste";
        } else {
          texto = `Expira em ${params.row.diasRestantes} ${
            params.row.diasRestantes === 1 ? "dia" : "dias"
          }`;
        }

        return (
          <span
            className={`marcacoesAdministrativo__nome__medico__span ${classeExtra}`}
          >
            {texto}
          </span>
        );
      },
    },
    {
      field: "instituicaoCobertura",
      headerName: "Instituição",
      flex: 1,
      renderCell: (params) => {
        return (
          <span
            className={`marcacoesAdministrativo__nome__medico__span ${
              params.row.expirado && "modalCredencial__row__expirado"
            }`}
          >
            {params.row.instituicaoCobertura}
          </span>
        );
      },
    },
    {
      field: "total",
      headerName: "Total",
      flex: 1,
      renderCell: (params) => {
        return (
          <span
            className={`marcacoesAdministrativo__nome__medico__span ${
              params.row.expirado && "modalCredencial__row__expirado"
            }`}
          >
            {params.row.total}
          </span>
        );
      },
    },
  ];

  // Contar expirados, em ajuste e a expirar
  const expirados = rows.filter((row) => row.expirado).length;
  const emAjuste = rows.filter((row) => row.emAjuste).length;
  const aExpirar = rows.filter((row) => !row.expirado && !row.emAjuste).length;

  const searchHandler = (e) => {
    setSearchTerm(e.target.value);
  };

  const filterData = () => {
    // ✅ CORREÇÃO: Verificar se permRows tem dados
    if (!permRows || permRows.length === 0) return;

    let filteredData = [...permRows];

    // Filtro por nome
    if (searchTerm) {
      filteredData = filteredData.filter((dt) =>
        dt.nome.toLowerCase().includes(searchTerm.toLowerCase()),
      );
    }

    // Filtro por data
    if (dataInicio || dataFim) {
      filteredData = filteredData.filter((dt) => {
        if (!dt.dataExpiracaoCredencial) return false;

        try {
          // ✅ SOLUÇÃO ROBUSTA: Aceita tanto "/" quanto "-" como separadores
          const [datePart] = dt.dataExpiracaoCredencial.split(" "); // Pega só a parte da data
          const [day, month, year] = datePart.split(/[/-]/); // Aceita tanto "/" quanto "-"
          const dataExpiracao = new Date(year, month - 1, day);

          // Verificar se a data é válida
          if (isNaN(dataExpiracao.getTime())) return false;

          if (dataInicio && dataFim) {
            const inicio = new Date(dataInicio);
            const fim = new Date(dataFim);
            inicio.setHours(0, 0, 0, 0);
            fim.setHours(23, 59, 59, 999);
            return dataExpiracao >= inicio && dataExpiracao <= fim;
          } else if (dataInicio) {
            const inicio = new Date(dataInicio);
            inicio.setHours(0, 0, 0, 0);
            return dataExpiracao >= inicio;
          } else if (dataFim) {
            const fim = new Date(dataFim);
            fim.setHours(23, 59, 59, 999);
            return dataExpiracao <= fim;
          }

          return true;
        } catch (error) {
          console.warn(
            "Erro ao parsear data:",
            dt.dataExpiracaoCredencial,
            error,
          );
          return false;
        }
      });
    }

    setRows(filteredData);
  };

  const clearFilters = () => {
    setSearchTerm("");
    setDataInicio(null);
    setDataFim(null);
  };

  const handleExportar = () => {
    const sheetData = rows.map((dt) => ({
      Cliente: dt.nome,
      Contacto: dt.contacto || "-",
      Nr_Orcamento: dt.numeroOrcamento,
      Codigo_Orcamento: dt.codigo,
      Data_Emissao: dt.dataCredencial,
      Data_Expiracao: dt.dataExpiracaoCredencial,
      Credencial: dt.nrCredencial,
      Instituicao: dt.instituicaoCobertura,
      Dias_Ate_Expirar: dt.diasRestantes >= 0 ? dt.diasRestantes : "-",
      Total: dt.total,
      medico: dt.medicoResponsavel,
      status: dt.status,
    }));

    const data = new Date();
    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0"); // mês começa em 0
    const ano = data.getFullYear();

    const dataEmString = `${dia}-${mes}-${ano}`;

    generateExcelFile(
      `Credencias a expirar ${dataEmString}.xlsx`,
      "Credenciais",
      sheetData,
    );
  };

  return (
    <>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="fluxo-atendimento__modal__box"
          id="modalCredenciaisExpirar"
        >
          <div className="orcamentos-por-aprovar__modal__cabecalho">
            <h1 className="fluxo-atendimento__modal__titulo">
              Credenciais - {aExpirar} a expirar, {emAjuste} em janela de
              ajuste, {expirados} expiradas (Total: {rows.length})
            </h1>

            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={ptBR}
            >
              <div className="orcamentos-por-aprovar__filtros">
                <div className="date-filters__container">
                  <div className="date-filter">
                    <DatePicker
                      label="Data Início"
                      value={dataInicio}
                      onChange={(newValue) => setDataInicio(newValue)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          variant="outlined"
                        />
                      )}
                      inputFormat="dd/MM/yyyy"
                    />
                  </div>

                  <div className="date-filter">
                    <DatePicker
                      label="Data Fim"
                      value={dataFim}
                      onChange={(newValue) => setDataFim(newValue)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          variant="outlined"
                        />
                      )}
                      inputFormat="dd/MM/yyyy"
                    />
                  </div>

                  <div className="search__datatable__container">
                    <span>Procurar</span>
                    <input
                      type="search"
                      className="search__datatable__input"
                      placeholder="Procurar"
                      value={searchTerm}
                      onChange={searchHandler}
                    />
                  </div>

                  <button
                    className="clear-filters-btn"
                    onClick={handleExportar}
                    title="Exportar Xls"
                  >
                    Exportar
                  </button>

                  <button
                    className="clear-filters-btn"
                    onClick={clearFilters}
                    title="Limpar filtros"
                  >
                    Limpar
                  </button>
                </div>
              </div>
            </LocalizationProvider>
          </div>

          <div className="modalProcedimentosPorAgendar__container">
            {rows && (
              <div style={{ height: "80vh", width: "100%" }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={10}
                  rowsPerPageOptions={[10]}
                  initialState={{
                    sorting: {
                      sortModel: [{ field: "diasRestantes", sort: "desc" }],
                    },
                  }}
                />
              </div>
            )}
          </div>
          <div className="fluxo-atendimento__modal__bottom_btns">
            <span
              className="cancel-btn"
              onClick={handleClose}
              style={{ display: "block" }}
            >
              Fechar
            </span>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default memo(ModalCredenciais);
